// Local translations
export const T = {
  en_GB: {
    admin: "Admin",
    platformAdministration: "Platform administration for Quantfolio",
    tenants: "Tenants",
    tenantsDescription: "Manage tenant organizations, users, and feature flags.",
    usage: "Metered usage",
    usageDescription:
      "Metered 3rd-party + AI Inference cost per tenant per month, with type drilldown.",
    componentUsage: "Component Usage",
    componentUsageDescription: "See how many flows and PDF templates use each component.",
    tenantsOverview: "Tenants Overview",
    tenantsOverviewDescription:
      "View all tenants with usage statistics: users, activity, flows, and clients.",
    timeseriesInstruments: "Timeseries Instruments",
    timeseriesInstrumentsDescription:
      "QA view of every instrument in the timeseries database and its data status.",
  },
  nb_NO: {
    admin: "Admin",
    platformAdministration: "Plattformadministrasjon for Quantfolio",
    tenants: "Kunder",
    tenantsDescription: "Administrer kundeorganisasjoner, brukere og funksjonsflagg.",
    usage: "Målt forbruk",
    usageDescription: "Målt tredjeparts- og AI-kostnad per kunde per måned, med type-drilldown.",
    componentUsage: "Komponentbruk",
    componentUsageDescription: "Se hvor mange flyter og PDF-maler som bruker hver komponent.",
    tenantsOverview: "Kundeoversikt",
    tenantsOverviewDescription:
      "Se alle kunder med bruksstatistikk: brukere, aktivitet, flyter og klienter.",
    timeseriesInstruments: "Tidsserieinstrumenter",
    timeseriesInstrumentsDescription:
      "QA-visning av alle instrumenter i tidsseriedatabasen og deres datastatus.",
  },
} as const;
